import styled from "styled-components";
import tw from "twin.macro";
import GradientButton from "../../../../components/GradientButton";
import { COLORS } from "../theme";

const SectionTwo = styled.section`
  ${tw`relative flex items-center`}
  z-index: 1;
  min-height: 80vh;
  background: #fff;
`;

const SectionTwoInner = styled.div`
  ${tw`mx-auto text-center`}
  width: 100%;
  padding: 4.5rem var(--app-content-gutter) 4.25rem;
  max-width: 1440px;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  @media (min-width: 1024px) {
    padding-top: 3.5rem;
    padding-bottom: 4rem;
  }
`;

const ProblemTitle = styled.h2`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  line-height: 1.18;
  font-weight: 400;
  color: #5a5a5a;
  text-transform: uppercase;

  strong {
    color: ${COLORS.orange};
    font-weight: 700;
  }

  @media (max-width: 767px) {
    order: 1;
    max-width: 560px;
    font-size: 20px;
    line-height: 1.18;
  }
`;

const ProblemGrid = styled.div`
  ${tw`grid justify-center items-start mt-12`}
  grid-template-columns: repeat(2, minmax(120px, 150px));
  column-gap: 2.25rem;
  row-gap: 2.75rem;

  @media (max-width: 767px) {
    order: 3;
    margin-top: 4.5rem;
    grid-template-columns: repeat(2, minmax(112px, 140px));
    column-gap: 3.15rem;
    row-gap: 2.9rem;
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(180px, 220px));
    gap: 2rem;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, minmax(180px, 220px));
    column-gap: 3rem;
  }
`;

const ProblemCard = styled.div`
  ${tw`flex flex-col items-center text-center`}
`;

const ProblemIcon = styled.img`
  width: 82px;
  height: 82px;
  object-fit: contain;

  @media (min-width: 768px) {
    width: 118px;
    height: 118px;
  }
`;

const ProblemLabel = styled.div`
  margin-top: 0.85rem;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 0;
  color: #437672;
  text-transform: uppercase;

  @media (max-width: 767px) {
    margin-top: 0.75rem;
    font-size: 13px;
    line-height: 1.18;
  }
`;

const PracticeTitle = styled.h3`
  margin: 5.25rem 0 0;
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: 0;
  color: #437672;
  text-transform: uppercase;

  @media (max-width: 767px) {
    order: 2;
    margin-top: 2.4rem;
    max-width: 520px;
    font-size: 16px;
    line-height: 1.18;
  }
`;

const PracticeText = styled.p`
  margin: 2.35rem auto 0;
  max-width: 1280px;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 400;
  color: #4d4b4b;

  strong {
    font-weight: 700;
  }

  @media (max-width: 767px) {
    order: 4;
    margin-top: 5.25rem;
    max-width: 560px;
    font-size: 14px;
    line-height: 1.45;
  }

  @media (min-width: 1024px) {
    white-space: nowrap;
  }
`;

const SectionTwoCta = styled(GradientButton).attrs({
  as: "button",
  $variant: "teal",
})`
  margin-top: 2.6rem;
  width: fit-content;
  max-width: 100%;
  height: 40px;
  padding: 0 14px;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.15;
  font-weight: 500;
  white-space: nowrap;

  @media (max-width: 767px) {
    order: 5;
    margin-top: 3rem;
    width: auto;
    max-width: calc(100vw - 32px);
    padding: 0 10px;
    font-size: 12px;
  }
`;

export {
  SectionTwo,
  SectionTwoInner,
  ProblemTitle,
  ProblemGrid,
  ProblemCard,
  ProblemIcon,
  ProblemLabel,
  PracticeTitle,
  PracticeText,
  SectionTwoCta,
};
